<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-cards-sidebar" position="left" lockedOpen="gt-md">
        <customer-details-sidebar [user]="user"></customer-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CONTENT -->
    <div class="content" [ngClass]="this.view" style="overflow-y: scroll;">

        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap">
            <div class="card p-5" *ngFor="let card of cards" fxFlex="100">
                <!-- PREVIEW -->
                <div class="card-preview" fxFlex="100">

                    <div class="fuse-card" fxFlex="100">

                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between start">
                            <div class="h1">{{card.cardNumber}}</div>
                            <div class="h4 secondary-text" *ngIf="card.credits">{{'Available credits'|translate}}: {{card.credits}}</div>
                            <div class="h4 secondary-text" *ngIf="card.simpleCredits>0">{{'Available credits'|translate}}: {{card.simpleCredits}}</div>
                        </div>

                        <div class="p-16 red" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="card.suspended">
                            <div class="h5 red">{{'Card is suspended to'|translate}} {{card.suspendedTo|date: 'dd.MM.y': 'UTC': locale}}</div>
                        </div>

                        <div class="p-16 pt-0 line-height-1.75">
                            <table *ngIf="card.items.length>0">
                                <thead>
                                <tr>
                                    <th>{{'Service'|translate}}</th>
                                    <th>{{'Credits'|translate}}</th>
                                    <th>{{'Expiration date'|translate}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let item of card.items">
                                    <td>{{item.serviceName.length > 0 ? item.serviceName : 'For all services'|translate}}</td>
                                    <td>{{item.balance}}</td>
                                    <td>{{item.expirationDate|date: 'd.MM.y': 'UTC': locale}}</td>
                                </tr>
                                </tbody>
                            </table>
                            <div *ngIf="card.vouchers && card.vouchers.length>0">
                                <div *ngFor="let voucher of card.vouchers">
                                    <h3>
                                        <button *ngIf="!card.suspended" title="{{'Suspend'|translate}}" mat-button color="accent" (click)="showSuspendVoucherDialog(card, voucher)">
                                            <i class="icon-timer"></i>
                                        </button>
                                        {{voucher.name}}
                                        <span style="font-weight: bold; color: red; font-size: 12px;" *ngIf="!voucher.activeInMonday || !voucher.activeInTuesday || !voucher.activeInWednesday || !voucher.activeInThursday || !voucher.activeInFriday || !voucher.activeInSaturday || !voucher.activeInSunday">
                                            <br/><b>{{'Valid days of week'|translate}}:</b>&nbsp;
                                            <span *ngIf="voucher.activeInMonday">{{'Mondays'|translate}}, </span>
                                            <span *ngIf="voucher.activeInTuesday">{{'Tuesdays'|translate}}, </span>
                                            <span *ngIf="voucher.activeInWednesday">{{'Wednesdays'|translate}}, </span>
                                            <span *ngIf="voucher.activeInThursday"><br/>{{'Thursdays'|translate}}, </span>
                                            <span *ngIf="voucher.activeInFriday">{{'Fridays'|translate}}, </span>
                                            <span *ngIf="voucher.activeInSaturday">{{'Saturdays'|translate}}, </span>
                                            <span *ngIf="voucher.activeInSunday">{{'Sundays'|translate}}</span>
                                        </span>
                                        <span *ngIf="voucher.validFromHour" style="font-weight: bold; color: red; font-size: 12px;">
                                            <br/><b>{{'Valid from hour'|translate}}:</b> {{voucher.validFromHour}}
                                        </span>
                                        <span *ngIf="voucher.validToHour" style="font-weight: bold; color: red; font-size: 12px;">
                                            <br/><b>{{'Valid to hour'|translate}}:</b> {{voucher.validToHour}}
                                        </span>
                                    </h3>
                                    <p *ngIf="voucher.active">
                                        {{voucher.activeFromDate|date: 'dd.MM.y': 'UTC': locale}} -
                                        {{voucher.expirationDate|date: 'dd.MM.y': 'UTC': locale}}
                                    </p>
                                    <p *ngIf="!voucher.active">
                                        {{'Voucher is inactive.'|translate}}
                                    </p>
                                    <table style="width: 100%;">
                                        <tr *ngFor="let voucherItem of voucher.items">
                                            <td style="width: 80%;">{{voucherItem.serviceName}}</td>
                                            <td>{{voucherItem.balance}}</td>
                                        </tr>
                                    </table>
                                    <hr/>
                                </div>
                            </div>
                        </div>

                        <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <a mat-button color="accent"
                                   routerLink="/customers/cards/{{card.id}}/history/{{user.id}}">{{'HISTORY'|translate}}</a>

                                <a mat-button color="accent"
                                   routerLink="/customers/cards/{{card.id}}/error-logs/{{user.id}}">{{'ERROR LOGS'|translate}}</a>
<!--                                <a mat-button color="accent" (click)="acceptEntrance(card)"-->
<!--                                   *ngIf="!card.entranceAccepted">{{'ACCEPT ENTRANCE'|translate}}</a>-->
<!--                                <a mat-button style="color: green;"-->
<!--                                   *ngIf="card.entranceAccepted">{{'ACCEPTED'|translate}}</a>-->
                                <!--                                <a mat-button color="accent">{{'LOCK'|translate}}</a>-->

                                    <a mat-button color="accent" (click)="acceptExit(card)"
                                       *ngIf="!card.exitAccepted">{{'ACCEPT EXIT'|translate}}</a>
                                    <a mat-button style="color: green;"
                                       *ngIf="card.exitAccepted">{{'EXIT ACCEPTED'|translate}}</a>
                            </div>
                        </div>
                        <div *appHasRole="'ROLE_WORKER'" class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <a mat-button color="accent"
                                   *appHasRole="'ROLE_ADMIN'"
                                   routerLink="/customers/cards/{{card.id}}/add-item/{{user.id}}"
                                   [routerLinkActive]="[]">{{'ADD SERVICE'|translate}}</a>
                                <a mat-button color="accent"
                                   (click)="openMinusServiceDialog(card)"
                                   [routerLinkActive]="[]">{{'MINUS SERVICE'|translate}}</a>
                            </div>


                        </div>

                        <div *appHasRole="'ROLE_ADMIN'" class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <a mat-button color="accent"
                                   *appHasRole="'ROLE_ADMIN'"
                                   (click)="showAddVoucherDialog(card, false)"
                                   [routerLinkActive]="[]">{{'ADD VOUCHER'|translate}}</a>
                            </div>
                        </div>
                        <div *ngIf="user.canAddFirstTimeVoucher" class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <a mat-button color="accent"
                                   (click)="showAddVoucherDialog(card, true)"
                                   [routerLinkActive]="[]">{{'ADD FIRST TIME VOUCHER'|translate}}</a>
                            </div>
                        </div>

                        <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <a mat-button color="accent"
                                   (click)="getPdf(user, card)"
                                   [routerLinkActive]="[]">{{'QR CODE'|translate}}</a>

                                <a mat-button color="accent"
                                   (click)="showChangeCardNumberDialog(card)"
                                   [routerLinkActive]="[]">{{'CHANGE NUMBER'|translate}}</a>
                            </div>


                        </div>


                        <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <button
                                        mat-button
                                        class="mr-8"
                                        aria-label="Mark as returned"
                                        color="warn"
                                        (click)="markCardAsReturnedDialog(card)"
                                >
                                    {{'MARK AS RETURNED'|translate}}
                                </button>

                                <button
                                        *appHasRole="'ROLE_ADMIN'"
                                        mat-button
                                        class="mr-8"
                                        aria-label="Delete"
                                        color="warn"
                                        (click)="showConfirmCardDeleteDialog(card)"
                                >
                                    {{'DELETE'|translate}}
                                </button>

                                <a mat-button color="accent" *ngIf="card.suspended"
                                   (click)="showUnsuspendCardDialog(card)"
                                   [routerLinkActive]="[]">{{'UNSUSPEND'|translate}}</a>
                            </div>
                        </div>

                    </div>

                </div>
                <!-- / PREVIEW -->
            </div>


        </div>
    </div>

</div>
